export const common = {
  shadeMaterial: {
    changeColorData: ({ shade_material, base_product_color }) => {
      if (!shade_material) return;
      const color_code = base_product_color[shade_material.bpc_target_key] || base_product_color.color_code2;
      shade_material.color_code = color_code;
    },
  },
};
